/* eslint-disable react/prop-types */
import React, { useReducer, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
// import Konva from 'konva';
// import { Textures } from './Textures';
// import { BrushRectangle, BrushTriangleLeft, BrushTriangleRight } from './Brushes';
import shapeList from './SoundShapes';

const textureList = ['one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight'];

const useKeyPress = (targetKey) => {
  const [keyPressed, setKeyPressed] = useState(false);

  useEffect(() => {
    const downHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(true);
      }
    };

    const upHandler = ({ key }) => {
      if (key === targetKey) {
        setKeyPressed(false);
      }
    };

    window.addEventListener('keydown', downHandler);
    window.addEventListener('keyup', upHandler);

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [targetKey]);

  return keyPressed;
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'arrowUp':
      return {
        selectedTextureIndex:
          state.selectedTextureIndex !== 0 ? state.selectedTextureIndex - 1 : textureList.length - 1
      };
    case 'arrowDown':
      return {
        selectedTextureIndex:
          state.selectedTextureIndex !== textureList.length - 1 ? state.selectedTextureIndex + 1 : 0
      };

    case 'arrowLeft':
      return {
        selectedFormIndex:
            state.selectedFormIndex !== 0 ? state.selectedFormIndex - 1 : shapeList.length - 1
      };
    case 'arrowRight':
      return {
        selectedFormIndex:
            state.selectedFormIndex !== shapeList.length - 1 ? state.selectedFormIndex + 1 : 0
      };

    case 'select':
      return {
        selectedFormIndex: action.payload
      };

    default:
      throw new Error();
  }
};

const initialFormState = {
  selectedFormIndex: 0
};

const initialTextureState = {
  selectedTextureIndex: 0
};

// eslint-disable-next-line react/prop-types, react/display-name
const BrushSelector = forwardRef((props, ref) => {
  const [selectedTexture, setSelectedTexture] = useReducer(reducer, initialTextureState);
  const [selectedForm, setSelectedForm] = useReducer(reducer, initialFormState);
  const arrowUpPressed = useKeyPress('ArrowUp');
  const arrowDownPressed = useKeyPress('ArrowDown');
  const arrowLeftPressed = useKeyPress('ArrowLeft');
  const arrowRightPressed = useKeyPress('ArrowRight');

  useImperativeHandle(ref, () => ({
    setSelectedTexture
  }));

  useEffect(() => {
    handleChange();
  }, [selectedTexture]);

  useEffect(() => {
    handleChange();
  }, [selectedForm]);

  function handleChange () {
    props.onChange && (props.onChange(selectedTexture, selectedForm));
  }

  useEffect(() => {
    if (arrowUpPressed) {
      setSelectedTexture({ type: 'arrowUp' });
    }
  }, [arrowUpPressed]);

  useEffect(() => {
    if (arrowDownPressed) {
      setSelectedTexture({ type: 'arrowDown' });
    }
  }, [arrowDownPressed]);

  useEffect(() => {
    if (arrowLeftPressed) {
      setSelectedForm({ type: 'arrowLeft' });
    }
  }, [arrowLeftPressed]);

  useEffect(() => {
    if (arrowRightPressed) {
      setSelectedForm({ type: 'arrowRight' });
    }
  }, [arrowRightPressed]);

  return (<></>);
});

export default React.memo(BrushSelector);
